module.exports = __webpack_public_path__ + "static/media/public-eye.6afba2e8.svg";